import { useEffect, useRef } from "react";
import { api } from "@/lib/api";

function uid() {
  return (crypto?.randomUUID?.() || (Date.now().toString(36) + Math.random().toString(36).slice(2)));
}

function getVisitorId() {
  let v = localStorage.getItem("intersect_vid");
  if (!v) { v = uid(); localStorage.setItem("intersect_vid", v); }
  return v;
}

function getSessionId() {
  let s = sessionStorage.getItem("intersect_sid");
  if (!s) { s = uid(); sessionStorage.setItem("intersect_sid", s); }
  return s;
}

// Fires a pageview on each public route change and keeps a heartbeat for active-now / duration.
export function usePageTracking(pathname) {
  const pingRef = useRef(null);

  useEffect(() => {
    if (!pathname || pathname.startsWith("/admin")) return;
    const payload = {
      session_id: getSessionId(),
      visitor_id: getVisitorId(),
      path: pathname,
      referrer: document.referrer || "",
      screen: `${window.screen?.width || 0}x${window.screen?.height || 0}`,
    };
    api.post("/track", payload).catch(() => {});

    const ping = () => {
      if (document.visibilityState !== "visible") return;
      api.post("/track/ping", { session_id: payload.session_id, path: pathname }).catch(() => {});
    };
    pingRef.current = setInterval(ping, 20000);
    return () => clearInterval(pingRef.current);
  }, [pathname]);
}
